<template>
  <div class="main-content-container overflow-hidden">
    <PageTitle pageTitle="Mi Perfil" subTitle="Perfil" />

    <MyProfile />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import PageTitle from "@/components/Common/PageTitle.vue";
import MyProfile from "@/components/Others/Settings/MyProfile/index.vue";

export default defineComponent({
  name: "MyProfilePage",
  components: {
    PageTitle,
    MyProfile,
  },
});
</script>
